import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Background } from "./Background";
import { QuoteButton } from "../../../components/QuoteButton";
import { fadeUpSx } from "../../../styles/animations";

export function Hero({ background }) {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        minHeight: "100svh",
        display: "flex",
        alignItems: { xs: "flex-end", md: "center" },
        overflow: "hidden",
        pb: { xs: 10, md: 0 },
      }}
    >
      <Background background={background} />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          background: {
            xs: "linear-gradient(180deg, rgba(11,11,11,0.2) 0%, rgba(11,11,11,0.75) 55%, #0B0B0B 100%)",
            md: "linear-gradient(90deg, rgba(11,11,11,0.9) 0%, rgba(11,11,11,0.6) 35%, rgba(11,11,11,0) 65%), linear-gradient(180deg, transparent 75%, #0B0B0B 100%)",
          },
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        <Box
          sx={{
            maxWidth: { xs: 560, md: 480 },
            ml: { xs: "auto", md: 0 },
            mr: "auto",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography variant="overline" component="p" sx={{ color: "primary.main", mb: 2, ...fadeUpSx(0.1) }}>
            Música ao vivo para eventos
          </Typography>

          <Typography variant="h1" sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem", md: "4.75rem" }, ...fadeUpSx(0.25) }}>
            Groowv{" "}
            <Box component="span" sx={{ color: "primary.main" }}>
              Electric Band
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 3,
              color: "text.secondary",
              fontSize: { xs: "1rem", md: "1.2rem" },
              lineHeight: 1.7,
              ...fadeUpSx(0.4),
            }}
          >
            Casamentos, eventos corporativos e festas embalados pela energia de uma banda ao vivo.
          </Typography>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{ mt: 5, justifyContent: { xs: "center", md: "flex-start" }, ...fadeUpSx(0.55) }}
          >
            <QuoteButton size="large" sx={{ px: 4, py: 1.5 }} />
            <Button component={RouterLink} to="/videos" variant="outlined" size="large" sx={{ px: 4, py: 1.5 }}>
              Assistir vídeos
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
